import posthog from 'posthog-js';

interface UserProperties {
    name?: string | null;
    email?: string | null;
    role?: string;
    tenant_id?: string;
    pipelines_count?: number;
    is_admin?: boolean;
    created_at?: string;
}

interface GroupProperties {
    pipelines_count?: number;
    created_at?: string;
    plan?: string;
}

const setUserProperties = (properties: UserProperties): void => {
    if (posthog) {
        posthog.people.set(properties);
    }
};

const setUserProperty = (key: keyof UserProperties, value: unknown): void => {
    if (posthog) {
        posthog.people.set({ [key]: value });
    }
};

const setGroupProperties = (
    groupType: string,
    groupId: string,
    properties: GroupProperties,
): void => {
    if (posthog) {
        posthog.group(groupType, groupId, properties);
    }
};

const resetUserProperties = (): void => {
    if (posthog) {
        posthog.reset();
    }
};

export {
    setUserProperties,
    setUserProperty,
    setGroupProperties,
    resetUserProperties,
};

export type { UserProperties, GroupProperties };
